module.exports = __webpack_public_path__ + "app/img/Touring_french.9a4758ae.jpg";